export enum View {
  Mobile = 'Mobile',
  DesktopLoggedIn = 'DesktopLoggedIn',
  DesktopLoggedOut = 'DesktopLoggedOut',
}
